var _path, _path2, _circle, _circle2, _circle3, _path3, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 480,
    width: 640,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#c4272f",
    d: "M0 0h640v480H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#015197",
    d: "M213.333 0h213.333v480H213.333z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 106.667,
    cy: 189.333,
    r: 29.333,
    fill: "#f9cf02"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.667,
    cy: 176,
    r: 32,
    fill: "#c4272f"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.667,
    cy: 181.333,
    r: 21.333,
    fill: "#f9cf02"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M93.333 141.333a13.333 13.333 0 0 0 26.667 0c0-5.333-3.333-6-3.333-8s2-4.666-2-8c2 3.334-1.334 4-1.334 7.334 0 3.333 1.334 3.333 1.334 6M48 224v128h26.667V224zm90.667 0v128h26.666V224zM80 245.333V256h53.333v-10.667zM80 320v10.667h53.333V320zm0-96h53.333l-26.666 16zm0 112h53.333l-26.666 16z",
    fill: "#f9cf02"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 80) scale(.13333)",
    fill: "#f9cf02",
    stroke: "#c4272f",
    strokeWidth: 24
  }, /*#__PURE__*/React.createElement("circle", {
    r: 212,
    cy: 1560,
    cx: 800
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800 1348a106 106 0 0 1 0 212 106 106 0 0 0 0 212",
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 80) scale(.13333)",
    fill: "#c4272f"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 800,
    cy: 1454,
    r: 40
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 800,
    cy: 1666,
    r: 40
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMn);
export default __webpack_public_path__ + "static/media/mn.892e352860c50d575d4675457b45d722.svg";
export { ForwardRef as ReactComponent };